// @ts-nocheck

import React from 'react';
import styled, { keyframes } from 'styled-components';

import theme from '../../styled-components/dark';
import { BasketStatuses } from '../../types/basket';

const LOADER_DIMENSION = 1.4;

const rotatorLoading = keyframes`
  0% {
    transform: translate(-50%, -50%) rotate(0deg);
  }

  100% {
    transform: translate(-50%, -50%) rotate(360deg);
  }
`;

const afterLoading = keyframes`
  0% {
    transform: translate(-50%, -50%) scale(1);
  }

  50% {
    transform: translate(-50%, -50%) scale(3)
  }

  100% {
    transform: translate(-50%, -50%) scale(1);
  }
`;

const Wrapper = styled.div`
  position: relative;
  width: ${LOADER_DIMENSION}em;
  height: ${LOADER_DIMENSION}em;

  background-color: white;
  border-radius: 50%;
  overflow: hidden;
  transform: translate3d(0, 0, 0);
`;

const PendingLoaderInner = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  height: 88%;
  width: 88%;
  transform: translate(-50%, -50%);
  border-radius: 50%;
  background-color: ${theme.BasketAlert[BasketStatuses.PENDING].backgroundColor};
  overflow: hidden;
  z-index: 2;
`;

const PendingLoaderCenter = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  height: ${LOADER_DIMENSION / 4.5}em;
  width: ${LOADER_DIMENSION / 4.5}em;
  border-radius: 50%;

  transform: translate(-50%, -50%);
  background-color: white;

  z-index: 3;
`;

const Rotator = styled.div`
  content: '';
  position: absolute;
  left: 50%;
  top: 50%;
  height: 1px;
  width: ${LOADER_DIMENSION}em;
  transform: translate(-50%, -50%);
  background-color: #ffffff00;
  animation: ${rotatorLoading} ${({ $duration }) => `${$duration}ms ease-in-out infinite`};

  &:after {
    content: '';
    position: absolute;
    left: 100%;
    top: 50%;
    height: 10px;
    width: 10px;
    border-radius: 50%;
    background-color: rgb(136, 83, 0);
    transform: translate(-50%, -50%);
    animation: ${afterLoading} ${({ $duration }) => `${$duration}ms ease-in-out infinite`};
    z-index: 1;
  }
`;

type PropsType = {
  className?: string;
  duration?: number;
};

const PendingLoader = ({ className, duration = 1000 }: PropsType) => {
  return (
    <Wrapper className={className}>
      <PendingLoaderInner>
        <PendingLoaderCenter />
      </PendingLoaderInner>
      <Rotator $duration={duration} />
    </Wrapper>
  );
};

export default PendingLoader;
